import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Eye, EyeOff } from "react-feather";
import axios from "axios";
import { baseurl } from "../Baseurl"; // Ensure you have the correct baseurl
import { useNavigate } from "react-router-dom"; 
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import Swal from "sweetalert2"; 
import logo from "../components/img/logo.jpeg";


const Login = () => {

   const [email, setEmail] = useState("");
  const location = useLocation();

 useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const emailFromUrl = queryParams.get("email");

    if (emailFromUrl) {
      setEmail(emailFromUrl);

      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: "Account created successfully! Please log in now.",
        showConfirmButton: false,
        timer: 4000,
        timerProgressBar: true,
      });
    }
  }, [location.search]);

  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };


const [loading, setLoading] = useState(false);


const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true); // Start loader

  try {
    const response = await axios.post(`${baseurl}login`, { email, password });

    // Check if backend returned success or token
    if (!response.data.token) {
      Swal.fire({
        icon: 'error',
        title: 'Login Failed',
        text: response.data.message || 'Invalid credentials',
      });
      return;
    }

    const {
      token,
      userId,
      email: userEmail,
      organization_id,
      organization_name,
      org_2,
      org_2_name,
      org_3,
      org_3_name,
      org_4,
      org_4_name,
      org_5,
      org_5_name,
      org_6,
      org_6_name,
      org_7,
      org_7_name,
      org_8,
      org_8_name,
      org_9,
      org_9_name,
      org_10,
      org_10_name
    } = response.data;

    // Save to localStorage
    localStorage.setItem("auth_token", token);
    localStorage.setItem("adminID", userId);
    localStorage.setItem("admin_email", userEmail);
    localStorage.setItem("organization_id", organization_id);
    localStorage.setItem("default", organization_id);
    localStorage.setItem("organization_name", organization_name);

    const otherOrgs = [
      { id: org_2, name: org_2_name },
      { id: org_3, name: org_3_name },
      { id: org_4, name: org_4_name },
      { id: org_5, name: org_5_name },
      { id: org_6, name: org_6_name },
      { id: org_7, name: org_7_name },
      { id: org_8, name: org_8_name },
      { id: org_9, name: org_9_name },
      { id: org_10, name: org_10_name }
    ].filter(org => org.id);

    localStorage.setItem("other_org", JSON.stringify(otherOrgs));

    // Navigate to dashboard
    navigate("/dashboard");

  } catch (error) {
    console.error("Login failed:", error.response?.data?.message || error.message);

    Swal.fire({
      icon: 'error',
      title: 'Login Failed',
      text: error.response?.data?.message || 'Invalid credentials',
    });

  } finally {
    setLoading(false); // Stop loader
  }
};



  
  

  return (
    <div className=" ">
      <div className="container d-flex justify-content-center align-items-center vh-100">
      <div>

      <div className="text-center">
            <img src={logo} className="img-fluid logo" alt="Bosplan Logo" />
        </div>


      <div className="mb-3">
            <h3 className="text-dark cl1 h11">Welcome Back</h3>
            <p className="text-muted">Please sign in to continue</p>
          </div>




          <div
          className="card p-4  "
          style={{ maxWidth: "400px", width: "100%" }}
        >
 
          <form onSubmit={handleSubmit}>
            <div className="mb-3 text-start">
              <label htmlFor="email" className="form-label">
                Email Address
              </label>
              <input
                type="email"
                id="email"
                className="form-control"
                placeholder="Enter Your Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                 
              />
            </div>
            <div className="mb-1 text-start">
              <label htmlFor="password" className="form-label">
                Password <span className="text-danger">*</span>
              </label>
              <div className="input-group">
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  className="form-control"
                  placeholder="Enter Your Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                   
                />
                <div
                  className="pwhide"
                  onClick={togglePasswordVisibility}
                  style={{ cursor: "pointer" }}
                >
                  {showPassword ? 'Show' : 'Hide'}
                </div>
              </div>
            </div>

            <div>
            {/* <div className="form-check text-start">
  <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
  <label className="form-label" for="flexCheckDefault">
  Remember me
  </label>
</div> */}

{/* <div className=" form-label text-muted text-end">Forget Password?</div> */}

<div  className="text-end">
  <Link className="form-label text-muted text-end" to="/forgot-password" data-discover="true">Forget Password?</Link>
</div>

            </div>


            <div className="mt-3">
              {/* <button type="submit" className="btn submitbtnn w-100">
              Sign In
              </button> */}

              {loading ? (
  <div className="spinner-container">
    <div className="spinner"></div>
  </div>
) : (
  <button type="submit" className="btn submitbtnn w-100">Login</button>
)}



            </div>


            <p class="line-clamp-1">
              <span>Dont have Account?</span> 
            <Link class="" to="/create-account" data-discover="true">Create account</Link></p>
 
          </form>
        </div>



      </div>

        
      </div>
    </div>
  );
};

export default Login;
